import clsx from 'clsx';

export function BDHighlightTitle({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <h1
      className={clsx(
        '3xl:text-7xl xs:text-4xl text-center text-3xl capitalize lg:text-5xl',
        className
      )}
    >
      {children}
    </h1>
  );
  // <div className="relative mx-auto mb-2 flex max-w-fit flex-col items-center">
  //   <HorizontalLine className="absolute -bottom-2 w-full" />
  // </div>
}

export default function BDTitle({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <h1
      className={clsx(
        '3xl:text-4xl xs:text-2xl text-center text-xl capitalize lg:text-3xl',
        className
      )}
    >
      {children}
    </h1>
  );
  // <div className="relative mx-auto mb-2 flex max-w-fit flex-col items-center">
  //   <HorizontalLine className="absolute -bottom-2 w-full" />
  // </div>
}

export function BDSubtitle({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <h2 className={clsx('3xl:text-3xl text-xl capitalize leading-7 lg:text-2xl', className)}>
      {children}
    </h2>
  );
}

export function BDGoldH3({ children }: { children: React.ReactNode }) {
  return <h3 className="text-warm-gold text-xl font-light capitalize lg:text-2xl">{children}</h3>;
}
